module.exports = __webpack_public_path__ + "static/media/zero_circle.59b8f942.jpeg";